import axios from 'axios';
import Helper from './helper';


const axiosInstance = axios.create({
    baseURL: `${process.env.REACT_APP_WMS_API_BASE_URL}`
})

axiosInstance.interceptors.request.use((request) => {
    const token = localStorage.getItem('access_token')
    request.headers.Authorization = `Bearer ${token}`
    return request
},

    (err) => {
        Promise.reject(err)
    })


export default axiosInstance;